import React from 'react';
import {
  LayoutTemplate, Shapes, Type, Image, QrCode, BarChart3, Upload, Palette, Bookmark
} from 'lucide-react';

const toolbarItems = [
  { id: 'templates', icon: LayoutTemplate, label: 'Templates' },
  { id: 'elements', icon: Shapes, label: 'Elements' },
  { id: 'text', icon: Type, label: 'Text' },
  { id: 'media', icon: Image, label: 'Media' },
  { id: 'qrcode', icon: QrCode, label: 'QR Code' },
  { id: 'charts', icon: BarChart3, label: 'Charts' },
  { id: 'brand', icon: Bookmark, label: 'Brand' },
  { id: 'color', icon: Palette, label: 'Background' },

  { id: 'upload', icon: Upload, label: 'Upload' },
];

const LeftToolbar = ({ activePanel, onPanelChange }) => {
  return (
    <div className="w-20 bg-white border-r flex flex-col items-center py-4 gap-1">
      {toolbarItems.map((item) => {
        const Icon = item.icon;
        const isActive = activePanel === item.id;

        return (
          <button
            key={item.id}
            onClick={() => onPanelChange(isActive ? null : item.id)}
            className={`w-16 h-16 flex flex-col items-center justify-center gap-1 rounded-lg transition-all ${isActive
                ? 'bg-purple-100 text-purple-700'
                : 'hover:bg-gray-100 text-gray-600'
              }`}
            data-testid={`toolbar-${item.id}`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LeftToolbar;
